export const HelpContent = () => (
  <>
    <p>
      <b>Need help analyzing your Heatmap responses?</b>
      <br />
      <br />
      These articles in our Help Center may be just what you need:
    </p>
    <br />
    <p>
      <a
        target="_blank"
        href="https://helpcenter.aytm.com/hc/en-us/articles/360049487452-Analyze-a-Heatmap-"
        rel="noreferrer"
      >
        Analyzing Heatmap Results
      </a>
    </p>
    <br />
    <p>
      <a
        target="_blank"
        href="https://helpcenter.aytm.com/hc/en-us/articles/360050239791-Heatmap-Virtual-Questions"
        rel="noreferrer"
      >
        Using Virtual Questions with Heatmap
      </a>
    </p>
    <br />
    Search the Help Center or reach out in chat if you need more assistance.
  </>
)
